<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">Dashboard</h1>
      <div>
        <span
          class="btn-group pull-right m-l-20 p-1 bg-black-transparent-2 rounded"
          :class="{ 'text-gray': inverseMode }"
        >
          <a
            class="btn btn-sm btn-white btn-white-without-border"
            @click.prevent="handleChangeWidgetTheme('light')"
            :class="{ active: !inverseMode }"
            ><i class="fa fa-sun text-primary"></i> Light</a
          >
          <a
            class="btn btn-sm btn-white btn-white-without-border"
            @click.prevent="handleChangeWidgetTheme('inverse')"
            :class="{ active: inverseMode }"
            ><i class="fa fa-moon"></i> Dark</a
          >
        </span>
      </div>
    </div>
    <div class="ts-overflow-x-hidden">
      <total-card ref="totalCard" class="h-full" />
      <quotation-and-sale-order-and-sale-contract-statistic
        :inverseMode="inverseMode"
        class="h-full"
        ref="quotationAndSaleOrder"
      />
      <customer-and-vendor-invoice-statistic
        :inverseMode="inverseMode"
        class="h-full"
        ref="customerAndVendor"
      />
      <cash-collection-by-cashier-and-top-10-fast-product-sold
        :inverseMode="inverseMode"
        class="h-full"
        ref="cashCollectionByCashierAndTopTen"
      />
      <sale-product-by-group
        :inverseMode="inverseMode"
        class="h-full"
        ref="saleProduct"
      />
      <promotion-and-top-10-slow-sold
        :inverseMode="inverseMode"
        class="h-full"
        ref="promotionandtop10"
      />
      <nearly-expired-and-re-order-product
        :inverseMode="inverseMode"
        class="h-full"
        ref="nearlyExpired"
      />
      <balance-inventory-by-branch
        :inverseMode="inverseMode"
        class="h-full"
        ref="balanceInventoryByBranch"
      />
    </div>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import TotalCard from './dashboard/total-card'
import SaleProductByGroup from './dashboard/widget/sale-product-by-group'
import PromotionAndTop10SlowSold from './dashboard/widget/promotion-and-top10-slow-sold'
import QuotationAndSaleOrderAndSaleContractStatistic from './dashboard/widget/quotation-and-sale-order-and-sale-contract-statistic'
import CustomerAndVendorInvoiceStatistic from './dashboard/widget/customer-and-vendor-invoice-statistic'
import CashCollectionByCashierAndTop10FastProductSold from './dashboard/widget/cash-collection-by-cashier-and-top10-fast-product-sold'
import NearlyExpiredAndReOrderProduct from './dashboard/widget/nearly-expired-and-re-order-product'
import BalanceInventoryByBranch from './dashboard/widget/balance-inventory-by-branch.vue'
export default {
  name: 'dashboard-v2',
  components: {
    TotalCard,
    SaleProductByGroup,
    PromotionAndTop10SlowSold,
    QuotationAndSaleOrderAndSaleContractStatistic,
    CustomerAndVendorInvoiceStatistic,
    CashCollectionByCashierAndTop10FastProductSold,
    NearlyExpiredAndReOrderProduct,
    BalanceInventoryByBranch
  },
  data () {
    return {
      inverseMode: false
    }
  },
  created () {
    PageOptions.pageEmpty = false
  },
  methods: {
    handleChangeWidgetTheme: function (theme) {
      if (theme == 'light') {
        this.inverseMode = false
      } else if (theme == 'inverse') {
        this.inverseMode = true
      }
    },
    fetchChildComponenData () {
      this.$refs.totalCard.fetchTotal()
      this.$refs.cashCollectionByCashierAndTopTen.fetchData()
      this.$refs.quotationAndSaleOrder.fetchData()
      this.$refs.customerAndVendor.fetchData()
      this.$refs.nearlyExpired.fetchData()
      this.$refs.balanceInventoryByBranch.fetchResource()
      this.$refs.saleProduct.selected = Object.keys(
        this.$refs.saleProduct.optionFilters
      )[0]
      this.$refs.saleProduct.fetchData({
        sale_date_by: this.$refs.saleProduct.selected
      })
      this.$refs.promotionandtop10.selected = Object.keys(
        this.$refs.saleProduct.optionFilters
      )[0]
      this.$refs.promotionandtop10.fetchData({
        sale_date_by: this.$refs.promotionandtop10.selected
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchChildComponenData()
    })
  }
}
</script>
